<template>  
 <div class="global-loader">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  
  <nav v-if="headerComponent"  >
    
      <component  :is="headerComponent"/>
   
  </nav>  
 
    <router-view/>
    
  <footer v-if="footerComponent">
    <component   :is="footerComponent" />
  </footer>
  
</template>
<style scoped>
.global-loader {
  position: fixed;
  z-index: 9999;
  background-color: rgba(255,255,255,0.7);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none; /* Start hidden */
  align-items: center;
  justify-content: center;
  display: flex; /* Needed to show spinner in center */
}

</style>

<style>
body{
    font-family: arial;
}
th{
  background: #00007c !important;
  color: white !important;
  padding: 8px 5px !important;
}
@media (max-width:600px)  { 
 #topline-tab{
  DISPLAY: flex;
    overflow-x: scroll;
    overflow-y: hidden;
 }
}
.form-control{
    padding: 0.25rem 0.25rem;
}
body,button, input, optgroup, select, textarea {
    
 
}
.form-control:focus{
    box-shadow: 0 0 0 0.02rem rgb(0 103 255);
}
:root{
    --theme-deafult:#003171;
}
table.dataTable  .badge {
    line-height: 10px !important;
}
template{
    display: block!important;
}
.form-label {
    margin-bottom: 4px;
    font-size: small;
    color: #3c3c3c;
}
.name_suggetion_list{
    /*height: 250px;*/
    max-height: 250px;
    overflow-y:  scroll;
}


/* 10.05.2025 */
.page-wrapper .page-header .header-wrapper{
    padding: 2px 30px;
}
.page-wrapper.compact-wrapper .page-body-wrapper .page-body{
    margin-top: 26px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-icon-wrapper{
    padding: 10px 30px;
}
.card .card-body{
    padding: 10px 20px;
}
.dataTables_wrapper .dataTables_filter{
    margin-bottom: 05px;
}
.card .card-header{
    padding: 10px 20px;
}
tbody tr:hover {
  background-color: antiquewhite !important;
}
.dataTables_wrapper table.dataTable th, .dataTables_wrapper table.dataTable td{
    padding: 0.25rem;
}
@media only screen and (max-width: 991.98px){
    .page-wrapper.compact-wrapper .page-body-wrapper .page-body{
    margin-top: 50px;
      padding: 5px 10px !important;
    }   
    .card .card-header{
        padding: 5px 10px !important;
    }
    .page-wrapper .card .card-header, .page-wrapper .card .card-body, .page-wrapper .card .card-footer {
        padding: 10px!important;
    }
    .tab-pane .card-body{
        padding: 0 !important;
    }
    .container-fluid{
        padding: 0 !important;
    }
}
.dataTables_wrapper .dataTables_filter input[type=search] {
    border: 1px solid #003171;
    padding: 5px;
    margin-left: 10px;
    /* height: 37px; */
    border-radius: 0;
}
.form-control, .form-select {
    /*padding: 0.0rem 0.25rem;*/
    border: 1px solid #2469f9;
}
</style>
<style>
.table-responsive{
        width: 100% !important;
}
    .front_header{
      background: var(--theme-deafult);
    padding: 15px 5px !important;
}
.fixed-bottom i,.fixed-bottom small {
    color: var(--theme-deafult);
}
.meet_success  {
    color: var(--theme-deafult);
}
th{
    text-transform: uppercase;
}
.for_logo{
        width: 150px;
}
.select2-selection {
    padding: 0.30rem 0.50rem !important;
    border: 1px solid #000000!important;
    font-weight: 600!important;
    height: 35px !important;
}
.select2-selection{
        height: 35px !important;
        min-height: 35px !important;
        max-height: 35px !important;
}
.rec_count {
        padding: 0px 15px;
}
.mobile_view .border-tab.nav-tabs .nav-item .nav-link{
        font-size: 14px;
        padding: 0px
}
.pass_card-warning{
        border: 1px solid #ffae1a!important;
    border-radius: 8px;
}
.pass_card-success{
        border: 1px solid #00ac46!important;
    border-radius: 8px;
}
.pass_card-danger{
        border: 1px solid #fe6a49!important;
    border-radius: 8px;
}
</style>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import FooterPart from '@/components/Footer.vue'; 
import ModalsPart from '@/components/Modals.vue';
 

export default {
  
  name: 'App', 
  data() {
    return { 
        header_part: Header,
        footer_part: FooterPart,
       
    };
  },
  mounted() {
    setTimeout(() => $(".global-loader").hide(), 2000);  
  },
  computed: {
      
    // headerComponent() {
    //   return (!['vr','ap','vp','vehiclepassview','visitorgatepassview','employeegatepassview','printpass','login','visitorpage','capture','register','visitorprofile','visitorcreategatepass','approvegatepass','qrcodereader','/'].includes(this.$route.name))&&(this.$route.name)?this.header_part : null;
    // },
    
   
    // footerComponent() {
    //   return (!['vr','ap','vp','vehiclepassview','visitorgatepassview','employeegatepassview','printpass','login','visitorpage','capture','register','visitorprofile','visitorcreategatepass','approvegatepass','qrcodereader','/'].includes(this.$route.name))&&(this.$route.name)?this.footer_part : null;
    // },
    
    headerComponent() {
        // alert(this.$route.name);
          const excluded = ['TabWorkPermit','printwp','MobileScan','TabScan','TabGatepass','SecurityTab','empg','wp','ProfilePage','PastPage','ActivePage','vr','ap','vp','vehiclepassview','visitorgatepassview','employeegatepassview','printpass','login','visitorpage','capture','register','visitorprofile','visitorcreategatepass','approvegatepass','qrcodereader','homeregister'];
          return (this.$route.name=='' || !excluded.includes(this.$route.name)) ? this.header_part : null;
         // return ( !excluded.includes(this.$route.name)) ? this.header_part : null;
        },
        footerComponent() {
          const excluded = ['TabWorkPermit','printwp','MobileScan','TabScan','TabGatepass','SecurityTab','empg','wp','ProfilePage','PastPage','ActivePage','vr','ap','vp','vehiclepassview','visitorgatepassview','employeegatepassview','printpass','login','visitorpage','capture','register','visitorprofile','visitorcreategatepass','approvegatepass','qrcodereader','homeregister'];
          return (this.$route.name=='' || !excluded.includes(this.$route.name)) ? this.footer_part : null;
        }
  },
}

</script>